import { render, staticRenderFns } from "./loadingIcon.vue?vue&type=template&id=488f1a6e&scoped=true&"
import script from "./loadingIcon.vue?vue&type=script&lang=js&"
export * from "./loadingIcon.vue?vue&type=script&lang=js&"
import style0 from "./loadingIcon.vue?vue&type=style&index=0&id=488f1a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f1a6e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/loadingIcon.vue
// module id = null
// module chunks = 